module.exports = __webpack_public_path__ + "static/media/47whM1ZEvfU.eb137d63.png";